import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creare-cont',
  templateUrl: './creare-cont.component.html',
  styleUrls: ['./creare-cont.component.scss']
})
export class CreareContComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
